import { Box, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import Image from "next/image";
import { pxToRem } from "@/util";
type props = {
  apartment: {
    name: string;
    image: string;
    // location: string;
    description: string;
    details: string;
    //propertyType: string;
    city?: string;
  };
  action: () => void;
};
export default function AppartmentCard({ apartment, action }: Partial<props>) {
  const { classes } = styles();

  return (
    <Box
      className={classes.container}
      onClick={() => action && action()}
      sx={{ cursor: action ? "pointer" : "default" }}
    >
      <Box className={classes.card}>
        <Box className={classes.img}>
          <Image
            src={apartment?.image || ""}
            alt={apartment?.name || ""}
            fill
            objectFit="cover"
          />
        </Box>
        <Box className={classes.overlay}></Box>
        <Box className={classes.footer}>
          <Box className={classes.footHead}>
            <Typography className={classes.footName}>
              {apartment?.name}
            </Typography>
            {/* <Typography className={classes.footLoc}>
              {apartment?.location}
            </Typography> */}
          </Box>
          <Typography className={classes.footDes}>
            {apartment?.details}
          </Typography>
          <Typography className={classes.footDet}>
            {apartment?.description}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    height: pxToRem(400),
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(3),
    borderRadius: pxToRem(15),
    backgroundColor: theme.colors.white,
    border: `0.5px solid #A3A3A3`,
    cursor: "pointer",
  },
  card: {
    position: "relative",
    width: "100%",
    display: "flex",
    flex: 1,
    height: "100%",
    borderRadius: pxToRem(8),
    overflow: "hidden",
  },
  img: {
    width: "100%",
    display: "flex",
    flex: 1,
  },
  overlay: {
    position: "absolute",
    background:
      "linear-gradient(0deg, rgba(0, 0, 0, 0.7) 21.34%, rgba(0, 0, 0, 0.60883) 35.82%, rgba(0, 0, 0, 0) 51.04%)",
    width: "100%",
    height: "100%",
  },
  footer: {
    height: pxToRem(170),
    marginBottom: pxToRem(8),
    overflow: "hidden",
    paddingLeft: pxToRem(25),
    width: "100%",
    display: "flex",
    alignSelf: "end",
    position: "relative",
    zIndex: 10,
    flexDirection: "column",
    gap: theme.spacing(1),
    maskImage: "linear-gradient(to bottom, black 70%, transparent 100%)",
    WebkitMaskImage: "linear-gradient(to bottom, black 70%, transparent 100%)",
    [theme.breakpoints.down(1360)]: {
      paddingLeft: pxToRem(24),
    },
  },

  footHead: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(3),
    alignItems: "center",
    [theme.breakpoints.down(1360)]: {
      flexDirection: "column",
      gap: theme.spacing(2),
      alignItems: "flex-start",
    },
  },
  footName: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(30),
    lineHeight: "120%",
    color: theme.colors.white,
    [theme.breakpoints.down(1360)]: {
      fontSize: pxToRem(25),
      width: "80%",
    },
  },
  footDes: {
    fontWeight: 500,
    fontSize: pxToRem(20),
    color: theme.colors.white,
    [theme.breakpoints.down(1360)]: {
      fontSize: pxToRem(19),
      width: "100%",
    },
  },
  footDet: {
    fontWeight: 400,
    fontSize: pxToRem(16),
    color: theme.colors.white,
    width: "70%",

    [theme.breakpoints.down(1360)]: {
      fontSize: pxToRem(15),
      width: "90%",
      fontWeight: 100,
    },
  },
  footLoc: {
    fontFamily: "Playfair Display",
    fontWeight: 400,
    fontSize: pxToRem(24),
    color: theme.colors.white,
    [theme.breakpoints.down(1200)]: {
      fontSize: pxToRem(16),
    },
    [theme.breakpoints.down(1360)]: {
      fontSize: pxToRem(20),
    },
  },
}));
